<template>
    <div>
      <v-dialog v-model="mostrarDialogoConfirmacaoReenvio" persistent :max-width="Modal.Confirmacao.larguraMaxima">
        <v-list-tile-title slot="activator">
          Solicitar Reenvio
        </v-list-tile-title>

        <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
            <v-card-title class="primary modal-title" primary-title>
              Solicitar Reenvio
            </v-card-title>
            <v-card-text class="pb-0 az-form-content">
                <v-textarea v-model="motivoReenvio"
                            :error-messages="errors.collect('Motivo')"
                            v-validate="mostrarDialogoConfirmacaoReenvio? 'required' : ''"
                            :name="'Motivo'"
                            label="Motivo"
                            placeholder="Digite aqui o motivo"
                            rows="3"
                            maxlength="1000"
                            :counter="1000"
                            class="required-field"/>
            </v-card-text>
            <v-card-actions class="px-3 py-2">
                <v-btn color="botao-cancelar-color" flat outline @click="mostrarDialogoConfirmacaoReenvio = false">
                  Cancelar
                </v-btn>
                <v-spacer/>
                <v-btn color="primary" depressed @click="confirmarSolicitacao">
                  Solicitar
                </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'AcoesSolicitarReenvioDocumento',
    data() {
        return {
            motivoReenvio: null,
            mostrarDialogoConfirmacaoReenvio: false,
            Modal
        }
    },
    methods: {
        fecharDialogoConfirmacaoReenvio(){
            this.mostrarDialogoConfirmacaoReenvio = false
        },
        async confirmarSolicitacao(){
            await this.validarCampos()
            this.fecharDialogoConfirmacaoReenvio()
            this.$emit('confirmarSolicitacao', this.motivoReenvio)
        },
        async validarCampos(){
            const estaValidado = await this.$validator.validateAll()
            if(!estaValidado){
                throw new Error('Preencha o campo Motivo obrigatório.')
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
          padding 0
          margin 0
          color #fff
          box-sizing border-box
          min-width 25px

    .botao-primario
      padding 0 25px
      border 1px solid var(--v-primary-base) !important
      background-color var(--v-primary-base) !important
      color #fff !important
      box-sizing border-box
      margin-left 15px !important

    .acoes
      padding 20px 0 !important

</style>